// import { StrictMode, useEffect } from "react";
// import { createRoot } from "react-dom/client";
// import { Hero } from "@/components/Hero";
// import { Navbar } from "@/components/Navbar";
// import "./styles.css";
// import { Routes, Route, BrowserRouter, useLocation } from "react-router-dom";
// import { ServicePage } from "@/features/services";
// import CaseStudiesPage from "@/features/services/components/CaseStudiesPage";
// import { TestimonialsPage } from "@/routes/testimonials";
// import { PrivacyPage } from "@/routes/privacy";
// import { TermsPage } from "@/routes/terms";
// import { SecurityPage } from "@/routes/security";
// import { IndiaEnquiryPage } from "@/routes/india-enquiry";
// import { AustraliaEnquiryPage } from "./routes/Australia-enquriy";
// import { NorthAmericaEnquiryPage } from "./routes/NorthAmerica-enquiry";
// import FooterContent from "./components/FooterContent";
// import { CareerPage } from "./components/CareerPage";
// import { AboutUsPage } from "./routes/about-us";
// import { ContactPage } from "./routes/contact";
// import { VideoTestimonials } from "./components/testimonials/VideoTestimonials";
// import { Quicklinks } from "./components/quicklinks";

// function ScrollToTop() {
//   const { pathname } = useLocation();

//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, [pathname]);

//   return null;
// }

// export function App() {
//   return (
//     <div className="bg-background min-h-screen text-foreground">
//       <ScrollToTop />
//       <Navbar />
//       <Routes>
//         <Route path="/" element={<Hero />} />
//         <Route path="/testimonials" element={<TestimonialsPage />} />
//         <Route path="/videotestimonials" element={<VideoTestimonials />} />
//         <Route path="/privacy" element={<PrivacyPage />} />
//         <Route path="/terms" element={<TermsPage />} />
//         <Route path="/security" element={<SecurityPage />} />
//         <Route path="/india-enquiry" element={<IndiaEnquiryPage />} />
//         <Route path="/australia-enquiry" element={<AustraliaEnquiryPage />} />
//         <Route path="/north-america-enquiry" element={<NorthAmericaEnquiryPage />} />
//         <Route path="/contact" element={<ContactPage />} />
//         <Route path="/career" element={<CareerPage />} />
//         <Route path="/about-us" element={<AboutUsPage />} />
//         <Route path="/footercontent" element={<FooterContent />} />
//         <Route path="/case-studies/:slug" element={<CaseStudiesPage />} />
//         <Route path="/:slug" element={<ServicePage />} />
//         <Route path="/solutions" element={<FooterContent />} />
//         <Route path="/quicklinks" element={<Quicklinks />} />
//       </Routes>
//     </div>
//   );
// }

// createRoot(document.getElementById("root")!).render(
//   <StrictMode>
//     <BrowserRouter basename={import.meta.env.BASE_URL}>
//       <App />
//     </BrowserRouter>
//   </StrictMode>,
// );


// import { StrictMode, useEffect, lazy, Suspense } from "react";
// import { createRoot } from "react-dom/client";
// // import { Hero } from "@/components/Hero";
// const Hero = lazy(() => import("@/components/Hero"));
// // ↑ Hero stays as normal import — it's the homepage, loads immediately
// const Navbar = lazy(() => import("@/components/Navbar"));
// import "./styles.css";
// import { Routes, Route, BrowserRouter, useLocation } from "react-router-dom";

// // ── LAZY IMPORTS — each page only loads when user visits that route ──
// const ServicePage            = lazy(() => import("@/features/services").then(m => ({ default: m.ServicePage })));
// const CaseStudiesPage        = lazy(() => import("@/features/services/components/CaseStudiesPage"));
// const TestimonialsPage       = lazy(() => import("@/routes/testimonials").then(m => ({ default: m.TestimonialsPage })));
// const PrivacyPage            = lazy(() => import("@/routes/privacy").then(m => ({ default: m.PrivacyPage })));
// const TermsPage              = lazy(() => import("@/routes/terms").then(m => ({ default: m.TermsPage })));
// const SecurityPage           = lazy(() => import("@/routes/security").then(m => ({ default: m.SecurityPage })));
// const IndiaEnquiryPage       = lazy(() => import("@/routes/india-enquiry").then(m => ({ default: m.IndiaEnquiryPage })));
// const AustraliaEnquiryPage   = lazy(() => import("./routes/Australia-enquriy").then(m => ({ default: m.AustraliaEnquiryPage })));
// const NorthAmericaEnquiryPage= lazy(() => import("./routes/NorthAmerica-enquiry").then(m => ({ default: m.NorthAmericaEnquiryPage })));
// const FooterContent          = lazy(() => import("./components/FooterContent"));
// const CareerPage             = lazy(() => import("./components/CareerPage").then(m => ({ default: m.CareerPage })));
// const AboutUsPage            = lazy(() => import("./routes/about-us").then(m => ({ default: m.AboutUsPage })));
// const ContactPage            = lazy(() => import("./routes/contact").then(m => ({ default: m.ContactPage })));
// const VideoTestimonials      = lazy(() => import("./components/testimonials/VideoTestimonials").then(m => ({ default: m.VideoTestimonials })));
// const Quicklinks             = lazy(() => import("./components/quicklinks").then(m => ({ default: m.Quicklinks })));

// function ScrollToTop() {
//   const { pathname } = useLocation();
//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, [pathname]);
//   return null;
// }

// export function App() {
//   return (
//     <div className="bg-background min-h-screen text-foreground">
//       <ScrollToTop />
//       <Navbar />
//       <Suspense fallback={<div className="flex items-center justify-center min-h-screen"><div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" /></div>}>
//         <Routes>
//           <Route path="/" element={<Hero />} />
//           <Route path="/testimonials" element={<TestimonialsPage />} />
//           <Route path="/videotestimonials" element={<VideoTestimonials />} />
//           <Route path="/privacy" element={<PrivacyPage />} />
//           <Route path="/terms" element={<TermsPage />} />
//           <Route path="/security" element={<SecurityPage />} />
//           <Route path="/india-enquiry" element={<IndiaEnquiryPage />} />
//           <Route path="/australia-enquiry" element={<AustraliaEnquiryPage />} />
//           <Route path="/north-america-enquiry" element={<NorthAmericaEnquiryPage />} />
//           <Route path="/contact" element={<ContactPage />} />
//           <Route path="/career" element={<CareerPage />} />
//           <Route path="/about-us" element={<AboutUsPage />} />
//           <Route path="/footercontent" element={<FooterContent />} />
//           <Route path="/case-studies/:slug" element={<CaseStudiesPage />} />
//           <Route path="/:slug" element={<ServicePage />} />
//           <Route path="/solutions" element={<FooterContent />} />
//           <Route path="/quicklinks" element={<Quicklinks />} />
//         </Routes>
//       </Suspense>
//     </div>
//   );
// }

// createRoot(document.getElementById("root")!).render(
//   <StrictMode>
//     <BrowserRouter basename={import.meta.env.BASE_URL}>
//       <App />
//     </BrowserRouter>
//   </StrictMode>,
// );


import { StrictMode, useEffect, lazy, Suspense } from "react";
import { HelmetProvider } from "react-helmet-async";
import { createRoot } from "react-dom/client";
import Hero from "@/components/Hero";
import Navbar from "@/components/Navbar";
import "./styles.css";
import { Routes, Route, BrowserRouter, useLocation } from "react-router-dom";

// ── LAZY IMPORTS — each page/component only loads when needed ──
const FloatingSocials        = lazy(() => import("@/components/FloatingSocials"));
const Toaster                = lazy(() => import("@/components/ui/sonner").then(m => ({ default: m.Toaster })));
const WhySanthilaPage        = lazy(() => import("./routes/WhySanthilaPage"));
const GlobalDeliveryPage     = lazy(() => import("./routes/global-delivery").then(m => ({ default: m.GlobalDeliveryPage })));
const ServicePage            = lazy(() => import("@/features/services").then(m => ({ default: m.ServicePage })));
const CaseStudiesPage        = lazy(() => import("@/features/services/components/CaseStudiesPage"));
const BlogPage               = lazy(() => import("@/features/blog/components/BlogPage"));
const TestimonialsPage       = lazy(() => import("@/routes/testimonials").then(m => ({ default: m.TestimonialsPage })));
const PrivacyPage            = lazy(() => import("@/routes/privacy").then(m => ({ default: m.PrivacyPage })));
const TermsPage              = lazy(() => import("@/routes/terms").then(m => ({ default: m.TermsPage })));
const SecurityPage           = lazy(() => import("@/routes/security").then(m => ({ default: m.SecurityPage })));
const IndiaEnquiryPage       = lazy(() => import("@/routes/india-enquiry").then(m => ({ default: m.IndiaEnquiryPage })));
const AustraliaEnquiryPage   = lazy(() => import("./routes/Australia-enquriy").then(m => ({ default: m.AustraliaEnquiryPage })));
const NorthAmericaEnquiryPage= lazy(() => import("./routes/NorthAmerica-enquiry").then(m => ({ default: m.NorthAmericaEnquiryPage })));
const FooterContent          = lazy(() => import("./components/FooterContent"));
const CareerPage             = lazy(() => import("./components/CareerPage").then(m => ({ default: m.CareerPage })));
const AboutUsPage            = lazy(() => import("./routes/about-us").then(m => ({ default: m.AboutUsPage })));
const ContactPage            = lazy(() => import("./routes/contact").then(m => ({ default: m.ContactPage })));
const VideoTestimonials      = lazy(() => import("./components/testimonials/VideoTestimonials").then(m => ({ default: m.VideoTestimonials })));
const Quicklinks             = lazy(() => import("./components/quicklinks").then(m => ({ default: m.Quicklinks })));
const WhatWeDoPage           = lazy(() => import("@/routes/what-we-do").then(m => ({ default: m.WhatWeDoPage })));
const RoadmapPage            = lazy(() => import("@/routes/roadmap").then(m => ({ default: m.RoadmapPage })));
const CompanyProfilePage     = lazy(() => import("@/routes/company-profile").then(m => ({ default: m.CompanyProfilePage })));
const DigitalProfilePage     = lazy(() => import("@/routes/digital-profile").then(m => ({ default: m.DigitalProfilePage })));
const OurCapabilityPage      = lazy(() => import("@/routes/our-capability").then(m => ({ default: m.OurCapabilityPage })));
const BoardOfDirectorsPage   = lazy(() => import("@/routes/board-of-directors").then(m => ({ default: m.BoardOfDirectorsPage })));
const SlugRouterPage         = lazy(() => import("@/routes/slug-router").then(m => ({ default: m.SlugRouterPage })));


function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export function App() {
  return (
    <div className="bg-background min-h-screen text-foreground">
      <ScrollToTop />
      <Navbar />
      <Suspense fallback={null}>
        <FloatingSocials />
        <Toaster position="top-right" />
      </Suspense>
      <Suspense fallback={<div className="flex items-center justify-center min-h-screen"><div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" /></div>}>
        <Routes>
          <Route path="/" element={<Hero />} />
          <Route path="/testimonials" element={<TestimonialsPage />} />
          <Route path="/videotestimonials" element={<VideoTestimonials />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/security" element={<SecurityPage />} />
          <Route path="/india-enquiry" element={<IndiaEnquiryPage />} />
          <Route path="/australia-enquiry" element={<AustraliaEnquiryPage />} />
          <Route path="/north-america-enquiry" element={<NorthAmericaEnquiryPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/career" element={<CareerPage />} />
          <Route path="/about-us" element={<AboutUsPage />} />
          <Route path="/footercontent" element={<FooterContent />} />
          <Route path="/case-studies" element={<CaseStudiesPage />} />
          <Route path="/case-studies/:slug" element={<CaseStudiesPage />} />
          <Route path="/blogs" element={<BlogPage />} />
          <Route path="/blog/:postId" element={<BlogPage />} />
          <Route path="/what-we-do" element={<WhatWeDoPage />} />
          <Route path="/roadmap" element={<RoadmapPage />} />
          <Route path="/company-profile" element={<CompanyProfilePage />} />
          <Route path="/digital-profile" element={<DigitalProfilePage />} />
          <Route path="/our-capability" element={<OurCapabilityPage />} />
          <Route path="/board-of-directors" element={<BoardOfDirectorsPage />} />
          <Route path="/solutions" element={<FooterContent />} />
          <Route path="/quicklinks" element={<Quicklinks />} />
          <Route path="/why-us" element={<WhySanthilaPage />} />
          <Route path="/global-delivery" element={<GlobalDeliveryPage />} />
          <Route path="/:slug" element={<SlugRouterPage />} />

        </Routes>
      </Suspense>
    </div>
  );
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <HelmetProvider>
      <BrowserRouter basename={import.meta.env.BASE_URL}>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </StrictMode>,
);
